import { useCallback, useState } from 'react';

/** Local loading state for one-off async actions (logout, form submits, etc.). */
export function useAsyncAction() {
  const [loading, setLoading] = useState(false);

  const run = useCallback(async <T,>(action: () => Promise<T>): Promise<T | undefined> => {
    setLoading(true);
    try {
      return await action();
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, run };
}
